import { capitalize } from 'lodash'

export default class {

	constructor(obj) {
		this.id = obj.id
		this.name = capitalize(obj.name)
		this.code = obj.code
		this.postalCode = obj.postal_code
		this.nameResearch = obj.nameresearch
		this.codeResearch = obj.coderesearch
		this.codeResearch = obj.postalcoderesearch
	}
}



// WEBPACK FOOTER //
// ./src/referential/dto/DtoCity.js